import { Stack } from '@karma/components';
import styled from 'styled-components';

export const ButtonsContainer = styled(Stack)`
  width: 332px;
`;
